import { useAppSelector } from "./useTypedSelector";
import { UserRole } from "../root/auth/domain/types/userRoleType";

export const useAuthorization = () => {
  const { user } = useAppSelector((state) => state.auth);

  return {
    hasRole: (role: UserRole) => {
      return user.role === role;
    },
  };
};
